module.exports = __webpack_public_path__ + "img/dangqianjihua.d4175219.png";